import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';  
import { validateHorizontalPosition } from '@angular/cdk/overlay';
import { ContentObserver } from '@angular/cdk/observers';
import html2canvas from 'html2canvas';
import jspdf from "jspdf";

@Component({
  selector: 'app-org',
  templateUrl: './org.component.html',
  styleUrls: ['./org.component.scss',
  "../../../../node_modules/ngx-org-chart/_theming.scss",
  ]
})


export class OrgComponent implements OnInit {
  @ViewChild('pdf', {static: false}) pdf: any; 

  constructor(public authService: AuthService,
              public router: Router) { 
  
    }
    bndmnugral=true;
    oculta_menu(){
      //console.log("-");
      if(this.bndmnugral==true){
        this.bndmnugral=false;
      }else{
        this.bndmnugral=true;
      }
      //console.log(this.bndmnugral);
    }

  menu_:boolean;
  nodes: any;  
  id_cliente;
  nombre;
   ngOnInit() {
    this.id_cliente=Number(localStorage.getItem("id_cliente"));
    this.nombre=localStorage.getItem("nom_cliente");
    this.org_=[];
    this.get_org();    

    this.selsiz = { nombre:"Tabloid" };
    this.selori = { nombre:"true", valor:true };
    this.selscale = { nombre: .1 };

    this.margin.push
      ({ 
        top: this.itmmargin.top.toString()+"cm", 
        bottom:this.itmmargin.bottom.toString()+"cm", 
        right:this.itmmargin.right.toString()+"cm", 
        left:this.itmmargin.left.toString()+"cm",
      });
   }
   selusu(id){
    this.org_aux=this.org;
    //console.log(this.org); 
    for(let i=0;i<this.org_.length;i++){
      if(this.org_[i].id_role==id){
        var foto_="";
        if (this.org_[i].foto==""){
          foto_="https://hoshinup.garocedev.com:3007/"+this.org_[i].foto;            
        }else{
          foto_="https://hoshinup.garocedev.com:3007/image-none.jpg";
        }
        var name=this.org_[i].role_card
        var css='{"id_persona":'+this.org_[i].id+',"id_role":'+this.org_[i].id_role+'}'
        var title=this.org_[i].persona
        var id_persona=this.org_[i].persona
        var id_role=this.org_[i].id_role
    
        //this.org_aux.splice(i, 1);
        
          this.nodes=[{
          name:name,
          cssClass:css,
          image:foto_,
          title:title, 
          childs:this.get_nodes(id_role,0)
          }];
          
      }
    }
  }

   org:any;
  class_:"cl_node";
  opt:any="vertical";
  org_=[];
  _go(a){
    //localStorage.setItem("menu_","1");    
    this.router.navigate([a]);
  }

  show__(t){
    switch(t){
      case 'ws':
        if(this.bndws==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bndws=true;
        }
      break;
      case 'nr':
        if(this.bndnr==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bndnr=true;
        }
        break;
      case 'do':
        if(this.bnddo==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bnddo=true;
        }
          break;
      case 'jd':      
        if(this.bndJD==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bndJD=true;
        }
        break;
      case 'cda':
        if(this.bndcda==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bndcda=true;
        }
        break;
      case 'kdr':
        if(this.bndkdr==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bndkdr=true;
        }   
        break;
      case 'kpi':
        if(this.bndkpi==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bndkpi=true;
        }
        break;
      case 'dke':
        if(this.bnddke==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bnddke=true;
        }
        break;
        case 'we':
          if(this.bndwe==true){
            this.limpia_role();
          }else{
            this.limpia_role();
            this.bndwe=true;
          }
        break;
        case 'edu':
          if(this.bndedu==true){
            this.limpia_role();
          }else{
            this.limpia_role();
            this.bndedu=true;
          }
        break;
        case 'jcom':
          if(this.bndjcom==true){
            this.limpia_role();
          }else{
            this.limpia_role();
            this.bndjcom=true;
          }
        break;
        case 'phy':
          if(this.bndphy==true){
            this.limpia_role();
          }else{
            this.limpia_role();
            this.bndphy=true;
          }
        break;
    }
  
  }
  bndDepa=false;
  migrate=0;
  v_role=false;
  VentanaFix;
  are1=true;
  are2=true;
  area;
  hidCvePersona;
  sel1;
  n_are1(){

  }
  gda_are1(){

  }
  can_are1(){

  }
 
  exp={
    id:0,
    organo:0,
    directo:0,
    id_persona:0,
    posicion:"",
    txdirRep1:"",
    txdirRep2:"",
    descripcion:"",
    departamento:"",
    lider:0,
    chart:0
  }
  
  btnmigrate=false;
  msg_rolecard="";
  cda=[];
  ls_cda(id_){
    let postData = {id_role:id_} 
    //console.log(postData);
    this.authService.service("/api/get_cda_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.cda=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });  
  }
  kdr=[];
  ls_kdr(id_){
    let postData = {id_role:id_  } 
    //console.log(postData);
    this.authService.service("/api/get_kdr_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.kdr=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  we=[];
  ls_we(id_){
    let postData = {id_role:this.role_id} 
    //console.log(postData);
    this.authService.service("/api/get_we_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          
          this.we=data;
          
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });  
  }
  ls_kpi(id_){
    let postData = {id_role:id_ } 
    //console.log(postData);
    this.authService.service("/api/get_kpi_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.kpi=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  kpi=[];
  dke=[];
  ls_dke(id_){
    let postData = { id_role:id_ } 
    //console.log(postData);
    this.authService.service("/api/get_dke_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.dke=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  } 
 

  ht;
  bndws:boolean=false;
  bndJD:boolean=false;
  bndcda:boolean=false;
  bndkdr:boolean=false;
  bndkpi:boolean=false;
  bnddke:boolean=false;
  bndnr:boolean=false;
  bnddo:boolean=false;
  bndphy:boolean=false;
  bndjcom:boolean=false;
  bndedu:boolean=false;
  bndwe:boolean=false;
  _rolecard;
  _mAre1=0;
  _mAre2=0;
  ls_ht(){
    let postData = {
      id_role:this._rolecard.id
    } 
    this.ht=[];
    //console.log(postData);
    this.authService.service("/api/get_ht_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          for(var i=0;i<res.length;i++){
            this.ht.push({idx:(i+1),nombre:res[i].nombre,id:res[i].id});
          }
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        }); 
  }
  reportto:any;
  get_reportto(cve){
    this.reportto=[];
    //console.log("reporto");
    let postData = {
      id_persona:cve } 
      //console.log(postData);
      this.loading=true;
      this.authService.service("/api/get_reportto",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);                        
            this.reportto=data;
            this.loading=false;           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              this.loading=false;
              swal.fire('¡API incorrecta! reportto', '', 'error');
          });   
  
  
  }
  loading;
 

  limpia_role(){
    this.bndJD=false;
    this.bndcda=false;
    this.bndkdr=false;
    this.bndkpi=false;
    this.bnddke=false;
    this.bndnr=false;
    this.bnddo=false;
    this.bndphy=false;
    this.bndjcom=false;
    this.bndedu=false;
    this.bndwe=false;
    this.bndws=false;
    
  }
  jerarquizacion(id_role_usu){
    //console.log("jerarquizacoin");
    //console.log(id_role_usu);
    for(var i=0;i<this.org.length;i++){
      if(id_role_usu==this.org[i].idarea1){
        //console.log(this.org[i])
        if(this.org[i].organo=='D' || this.org[i].organo=='P'  || this.org[i].organo=='A'){         
          this.org_.push(this.org[i]);
          //this.jerarquizacion(this.org[i].id_role)
        }
      }
    }            
    
  }
  get_nodes_(id){
    var child:any=[];
    console.log(this.org);
    console.log(this.org);
    for(var x=0;x<this.org.length;x++){
      if (this.org[x].idarea1==id && this.org[x].directo==0){
        this.org_.push(this.org[x]);
        this.get_nodes_(this.org[x].id);
      }
    }
  } 
  org_aux;
  get_org(){
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    }      
    this.authService.service("/api/get_org_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
            //console.log(data);
              this.org=data;
              this.org_=[];
              this.org_=this.authService._org_jerarquizacion(data);
              
              //console.log("org");
              console.log(this.org_);
              var bnd=false;
              for(var i=0;i<this.org_.length;i++){
                if(this.org_[i].organo=='D' && this.org_[i].lider==1 && bnd==false){
                  bnd=true;
                  this.selusu(this.org_[i].id_role)
                }
              }
              
                    
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });   
    }
    txtRole=""
    txtPersona="";
    id_persona=0;
    id_depend=0;
  
    selComp=0;
    _competencia;
 
    nivel2=[];
    nivel3=[];
    nivel1=[];
    ls_area(){
      this.nivel2=[];
      this.nivel3=[];
      this.nivel1=[];
      let postData = {
        id_cliente:localStorage.getItem("id_cliente")
      }
      this.authService.service("/api/get_role2",postData)
      .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                     
          this.area=data;
          for(var i=0;i<this.area.length;i++){
            if(this.area[i].organo=='D'){
              this.nivel1.push(this.area[i]);
            }else if(this.area[i].organo=='P'){
              this.nivel2.push(this.area[i]);
            }else if(this.area[i].organo=='A'){
              this.nivel3.push(this.area[i]);
            }
          }  
          //console.log(data);       
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta!', '', 'error');
        });  
  
  }

    descipcion_we="";
    descipcion_edu="";
    descipcion_jcom="";
    descipcion_phy="";
    descipcion_cda="";
    descipcion_kpi="";
    descipcion_kdr="";
    descipcion_dke="";
    bndeditcda=false;
    bndeditkdr=false;
    bndeditkpi=false;
    bndeditdke=false;
    bndeditwe=false;
    bndeditedu=false;
    bndeditjcom=false;
    bndeditphy=false;
    id_kpi=0;
    id_kdr=0;
    id_edu=0;
    id_we=0;
    id_jcom=0;
    id_phy=0;
    id_cda=0; 
    edit_cda(itm){
      this.id_cda=itm.id;
      this.descipcion_cda=itm.descripcion;
      this.bndeditcda=true;
    }
    del_kdr(itm){
      if(confirm("Confirm to delete this row?")==false)return;
      let postData = {
        id:itm.id
    
      } 
        //console.log(postData);
        this.authService.service("/api/del_kdr",postData)
        .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);              
              if (res.length!=0)
              {
                this.ls_kdr(this.hidCvePersona);
              }           
            },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)
                swal.fire('¡API incorrecta!', '', 'error');
            }); 
    }
    del_kpi(itm){
      if(confirm("Confirm to delete this row?")==false)return;
      let postData = {
        id:itm.id
      } 
        //console.log(postData);
        this.authService.service("/api/del_kpi",postData)
        .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);              
              if (res.length!=0)
              {
                this.ls_kpi(this.hidCvePersona);
              }           
            },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)
                swal.fire('¡API incorrecta!', '', 'error');
            }); 
    }
    del_dke(itm){
      if(confirm("Confirm to delete this row?")==false)return;
      let postData = {
        id:itm.id
      } 
        //console.log(postData);
        this.authService.service("/api/del_dke",postData)
        .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);              
              if (res.length!=0)
              {
                this.ls_dke(this.hidCvePersona);
              }           
            },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)
                swal.fire('¡API incorrecta!', '', 'error');
            }); 
    }
    del_cda(itm){
      if(confirm("Confirm to delete this row?")==false)return;
      let postData = {
        id:itm.id
      } 
        //console.log(postData);
        this.authService.service("/api/del_cda",postData)
        .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);              
              if (res.length!=0)
              {
                this.ls_cda(this.hidCvePersona);
              }           
            },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)
                swal.fire('¡API incorrecta!', '', 'error');
            });   
    }

    
    empresa_="";
    txtanio;
    rpt_ht(itm){
      localStorage.setItem("t_ht","P");
      localStorage.setItem("id_ht",itm.id);
      //console.log(itm)
      this.router.navigate([]).then(result => {  window.open('./fmtht', '_blank'); }); 
    
    }
    

  
    

    img_per="";
    Role_per="";
    Nombre_per="";
    persona_id=0;
    list_per=1;
    role_id=0;
    empty_(){
      this.list_per=2;
      this.id_persona=0;
    }
    list_(){
      this.list_per=1;
    }
    editaper(){
      localStorage.setItem("id_persona",this.id_persona.toString())
      this.router.navigate(['/people']);
    }
    editarole(){
      localStorage.setItem("id_role",this.role_id.toString())
      this.router.navigate(['/rolecard']);
    }
    text_(){
      this.list_per=2;
    }
    editarole_(){}
    test($event){
      //console.log("test");
      
      var res=JSON.parse($event.cssClass);
      console.log(res);
      if(res.id_persona==null){        
        swal.fire('¡Puesto sin perfil asignado!', '', 'warning');
      }else{
        localStorage.setItem("perfil",$event.cssClass);
        this.router.navigate(["/perfil"]);
      }      
      return;
      
      this.depends=[];
      this.list_per=2;
      this.bndchart=2;
      this.Role_per=$event.name
      this.Nombre_per=$event.title
      this.img_per=$event.image
      this.id_persona=0;
      //console.log($event.cssClass);
     
      this.persona_id=res.id_persona;
      this.role_id=res.id_role;
      try {
        for(var i=0;i<$event.childs.length;i++){
          //console.log($event[i])
          this.depends.push($event.childs[i])

        }
      } catch (error) {
        
      }
    }
    depends=[];
    _regresa(){
      this.bndchart=1;
    }
    bndchart=1;
    get_nodes(id,d){      
      //console.log("get_nodes("+id+")")
      var bndIndirecto=0;
      var child:any=[];
      var aux=[];
      console.log(this.org_aux);
      for(var x=0;x<this.org_aux.length;x++){
        if (this.org_aux[x].idarea1==id  ){
          if(this.org[x].directo==0){
            var foto_="";
            try {
                if (this.org_aux[x].foto.length>0){
                foto_="https://hoshinup.garocedev.com:3007/"+this.org_aux[x].foto;            
              }else{
                foto_="https://hoshinup.garocedev.com:3007/image-none.jpg";
              }
            } catch (error) {
              foto_="https://hoshinup.garocedev.com:3007/image-none.jpg";
            }
            var name=this.org_aux[x].role_card
            var css='{"id_persona":'+this.org_aux[x].id+',"id_role":'+this.org_aux[x].id_role+'}'
            var title=this.org_aux[x].persona
            var id_role=this.org_aux[x].id_role              
            child.push({
              image: foto_,
              name:name,
              cssClass: this.class_,
              title:title,
              childs:this.get_nodes(id_role,0)
            });            
          }else  if(this.org[x].directo==1){
            bndIndirecto=1;
          }          
        }          
      }           
      if(bndIndirecto==1){
        child.push({
          image: "",
          name:"Indirecto",
          cssClass:"indirecto_head",
          title:"",
          childs:this.get_nodes_indirecto(id)
        });        
      }
      return child;
    }
    get_nodes_indirecto(id){            
      var bndIndirecto=0;
      var child:any=[];
      var aux=[];      
      for(var x=0;x<this.org_aux.length;x++){
        if (this.org_aux[x].idarea1==id  ){
          if(this.org[x].directo==1){
            var foto_="";
            try {
                if (this.org_aux[x].foto.length>0){
                foto_="https://hoshinup.garocedev.com:3007/"+this.org_aux[x].foto;            
              }else{
                foto_="https://hoshinup.garocedev.com:3007/image-none.jpg";
              }
            } catch (error) {
              foto_="https://hoshinup.garocedev.com:3007/image-none.jpg";
            }
            var name=this.org_aux[x].role_card
            var css='{"id_persona":'+this.org_aux[x].id+',"id_role":'+this.org_aux[x].id_role+'}'
            var title=this.org_aux[x].persona
            var id_role=this.org_aux[x].id_role              
            child.push({
              image: foto_,
              name:name,
              cssClass:"indirecto",
              title:title,
              childs:this.get_nodes_indirecto(id_role)
            });            
          }        
        }          
      }                 
      return child;
    }


    winprepdf:boolean = false;
    siz; selsiz;
    ori; selori;
    scale; selscale;
    itmmargin = { top:1, bottom:1, right:1, left:1, };

    itm={
      top:.1,
      right:.1,
      bottom:.1,
      left:.1,
    }
    margin = [];

    ls_prevpdf(){
      this.winprepdf = true;
      var siz = [];
      siz.push({  nombre:"Letter" });
      siz.push({  nombre:"Executive" });
      siz.push({  nombre:"Legal" });
      siz.push({  nombre:"Tabloid" });    
      this.siz = siz;

      var ori = [];
      ori.push({  nombre:"true", valor:true });
      ori.push({  nombre:"false", valor:false });
      this.ori = ori;


      var scale = [];
      scale.push({  nombre:.1  });
      scale.push({  nombre:.2  });
      scale.push({  nombre:.3  });
      scale.push({  nombre:.4  });
      scale.push({  nombre:.5  });
      scale.push({  nombre:.6  });
      scale.push({  nombre:.7  });
      scale.push({  nombre:.8  });
      scale.push({  nombre:.9  });
      scale.push({  nombre:1  });      
      this.scale = scale;
    }
  
    ls_pdfSave(){
      this.loading= true;
      this.margin = [];
      this.margin.push
      ({ 
        top: this.itmmargin.top.toString()+"cm", 
        bottom:this.itmmargin.bottom.toString()+"cm", 
        right:this.itmmargin.right.toString()+"cm", 
        left:this.itmmargin.left.toString()+"cm",
      });

      setTimeout(() => { 
        this.pdf.saveAs("chart_"+ + new Date().getTime() + ".pdf");   
        this.loading= false;
      }, 1000);
      
    }

    public captureScreen() {
      this.loading= true;
      var data = document.getElementById("contentToConvert");
      html2canvas(data).then(canvas => {
        // Few necessary setting options
        var imgWidth = this.imgWidth;
        var pageHeight = 80;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;
  
        const contentDataURL = canvas.toDataURL("image/png");
        let pdf = new jspdf("p", "mm", "a4"); // A4 size page of PDF
        var position = this.position;
        pdf.addImage(contentDataURL, "PNG", this.left, position, imgWidth, imgHeight);
        setTimeout(() => { 
          pdf.save("chart_"+ + new Date().getTime() + ".pdf");             
          this.loading= false;
        }, 1000);
      });
    }

    imgWidth = 110;
    position = 5;
    left = 50;
    winprepdfN: boolean = false;
    ls_prevpdfN(){
      this.winprepdfN = true;
    }
}
